import { Component, OnInit } from '@angular/core';
import { DynamicGridComponent } from '../../dynamic-entity/dynamic-entity.module';
import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../ubi-core/ubi-core.module';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UbiFilterService } from '../../theme/index';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-customer-reports',
  templateUrl: './customer-reports-loadtruck.component.html',
  styleUrls: ['./customer-reports.component.scss']
})

export class CustomerReportsLoadTruckComponent extends DynamicGridComponent implements OnInit {

  private truckLoadReports = [];
  private processing = false;

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService, protected toastr: ToastrService) {
    super(baseservice, metadataservice, router, route, modalService, filterservice);
  }

  ngOnInit() {

    super.ngOnInit();
    this.onDataLoaded.subscribe((data) => this.onGridDataLoaded(data));
  }

  /**
   * Get data on onInit
   * This is an override
   */
  protected getInitialData() {
    this.getGeneratedTruckLoadReports({ offset: 0 });
  }

  onGridDataLoaded(this, data) {
    this.truckLoadReports = data.data;
  }

  private getGeneratedTruckLoadReports(pageInfo) {
    const filter = new ExpressionFilter(Condition.AND);
    this.page.sorts = [{ prop: 'ReportNumber', dir: 'desc' }];
    this.baseservice.setEntity(this.entity);

    super.getPage(pageInfo, filter, 'GetGeneratedTruckLoadReports');
  }

  private sortGeneratedTruckLoadReports(sort) {
    this.baseservice.setEntity(this.entity);
    this.sortPage(sort, 'GetGeneratedTruckLoadReports');
  }

  getPage(pageInfo, filter, method = null) {
    super.getPage(pageInfo, filter, 'DetailedVesselUnloadMovements');
  }

  private exportTruckLoadMovements(item) {
    const reportRequest = {
      'Path': 'TruckLoadMovements',
      'Parameters': {
        'ReportNumber': item.ReportNumber,
        'Version': 1
      }
    };
    this.requestReport(reportRequest, 'TruckLoadMovements.pdf', 'PDF');
  }

  private requestReport(request: object, fileName: string, format: string) {
    this.processing = true;
    this.baseservice.setEntity('Reports/ExportTo' + format);
    this.baseservice.getFile(request, 'application/pdf').subscribe(
      response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response);
        link.download = fileName;
        link.click();
        this.processing = false;
      },
      error => {
        console.log('Error getting report: ' + error);
        this.toastr.error('Erro a gerar o relatório.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/customerReports/customer-reports-loadtruck.component.ts